import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import "./ui.scss";

/** Thin gold progress bar fixed to the top of the viewport, tied to page scroll. */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });
  return <motion.div className="scroll-progress" style={{ scaleX }} aria-hidden="true" />;
}
